// extracted by mini-css-extract-plugin
export default {"content":"US-z","lookName":"VS-z","shopTheLookContainer":"WS-z","productContainer":"XS-z","imageContainer":"YS-z","mainImage":"ZS-z"};